import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { ServiceBase } from '../../../shared/service-base/ServiceBase';

@Injectable()
export class VeiculosSemPassagensFiltroService extends ServiceBase {

  private baseUrlService: string;
  url: string;

  constructor(http: HttpClient, router: Router) {
    super(http, router);

    this.baseUrlService = environment.URL_API;
  }

  protected getURL(): string {
    return this.url;
  }

  private defineURLFiltroDealers() {
    this.url = `${this.baseUrlService}/filtro/dealer`;
  }

  getFiltroDealers(): any {
    this.defineURLFiltroDealers();
    return this.get([]);
  }

  private defineURLFiltroTipos() {
    // Mesmo endpoint de tipos de O.S. usado no RMPV Detalhado.
    this.url = `${this.baseUrlService}/tipo_os`;
  }

  getFiltroTipos(): any {
    this.defineURLFiltroTipos();
    return this.get([]);
  }
}